<div class="container bg-primary d-lg-none d-block">
  <fgb-barcode [showBarcode]="true"></fgb-barcode>
</div>

<!-- V2 Wallet -->
<ng-container *ngIf="walletItems$ | async as walletItems">
  <div class="wallet-redeem-carousel pt-4">
    <div class="container">
      <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
    </div>
  </div>
</ng-container>

<div class="container mt-3 text-center">
  <a class="font-size-14 claimed-text fw-bold" [routerLink]="['/rewards/claimed']">
    {{ 'rewards.wallet.view.claimed' | translate }}
  </a>
</div>

<fgb-campaigns-v2-offers-list [showAllOffers]="false"></fgb-campaigns-v2-offers-list>
